/*
 * The rows for photos that did not send (photoOutbox.ts): the picture, why, Try again and Remove. The visit pages show them
 * above the photos that made it.
 */
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { dropPhoto, retryPhoto, useHeldPhotos, whenPhotoSent, type HeldPhoto } from "./photoOutbox";
import { Button } from "./parts";

const WORDS = {
  en: { failed: "Didn't send", again: "Try again", remove: "Remove", sure: "Remove this photo? It is not on the visit yet." },
  es: {
    failed: "No se envió",
    again: "Intentar otra vez",
    remove: "Quitar",
    sure: "¿Quitar esta foto? Todavía no está en la visita.",
  },
};

/** Refreshes the visit once a kept photo finally sends. */
export function useHeldPhotoRefresh() {
  const qc = useQueryClient();
  useEffect(
    () =>
      whenPhotoSent(() => {
        void qc.invalidateQueries({ queryKey: ["visit"] });
        void qc.invalidateQueries({ queryKey: ["myvisit"] });
      }),
    [qc],
  );
}

function Row({ p, lang }: { p: HeldPhoto; lang: "en" | "es" }) {
  const w = WORDS[lang];
  const [asking, setAsking] = useState(false);
  return (
    <div className="item held-photo">
      <span className="file-pic">
        <img src={`data:${p.body.mime};base64,${p.body.dataBase64}`} alt="" />
      </span>
      <div className="what">
        <b className="held-photo-bad">{w.failed}</b>
        <span>{asking ? w.sure : p.error}</span>
      </div>
      <div className="row tight">
        {asking ? (
          <>
            <Button type="tertiary" size="small" onClick={() => setAsking(false)}>
              {lang === "es" ? "No" : "Keep"}
            </Button>
            <Button size="small" variation="destructive" onClick={() => dropPhoto(p.id)}>
              {w.remove}
            </Button>
          </>
        ) : (
          <>
            <Button size="small" loading={p.busy === true} onClick={() => void retryPhoto(p.id)}>
              {w.again}
            </Button>
            <Button type="tertiary" size="small" onClick={() => setAsking(true)}>
              {w.remove}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}

/** The kept photos for one place ("visits:<ref>" or "crew:<ref>"); nothing when there are none. */
export function HeldPhotos({ at, lang = "en" }: { at: string; lang?: "en" | "es" }) {
  const list = useHeldPhotos(at);
  useHeldPhotoRefresh();
  if (!list.length) return null;
  return (
    <div className="todo">
      {list.map((p) => (
        <Row key={p.id} p={p} lang={lang} />
      ))}
    </div>
  );
}
